import { codeFn } from './ownValidate.js';

export const RuleObj = function () {
    // 類似react的事件機制
    // const realNums = realNum.bind(this);
    return {
        name: [{ required: true, message: $t('integration.name_cannot_be_empty'), trigger: 'blur' },
        {
            max: 20,
            message: $t('integration.name_within_20'),
            trigger: 'blur'
        }
        ],
        code: [
            { required: true, message: $t('integration.type_code_cannot_be_empty'), trigger: 'blur' },
            {
                max: 20,
                message: $t('integration.type_name_within_20'),
                trigger: 'blur'
            },
            {
                validator: codeFn,
                trigger: 'blur'
            }
        ],
        data_type: [{ required: true, message: $t('integration.data_type_cannot_be_empty'), trigger: 'change' }],
        data_length: [{ required: true, message: $t('integration.length_cannot_be_empty'), trigger: 'blur' },
        // {
        //     validator: realNums,
        //     trigger: 'blur'
        // }
        ],
        data_rule: [{ required: true, message: $t('integration.rule_cannot_be_empty'), trigger: 'change' }],
        explain: [{ required: false, message: $t('integration.length_within_80'), trigger: 'blur', max: 80 }],
    }
}
